"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatMoney_1 = __importDefault(require("../../currency/formatMoney"));
function formatCents(locale, cents, options = {}) {
    const precision = options.precision ?? (cents % 100 ? 2 : 0);
    return (0, formatMoney_1.default)(locale, cents / 100, { ...options, precision });
}
exports.default = formatCents;
//# sourceMappingURL=formatCents.js.map